const volumeFormatter = new Intl.NumberFormat('fr-FR', {
  maximumFractionDigits: 0,
  minimumFractionDigits: 0,
});

const compactVolumeFormatter = new Intl.NumberFormat('fr-FR', {
  notation: 'compact',
  maximumFractionDigits: 1,
});

/** Rounds and formats tonne volumes using French number conventions (e.g. 1 234 567). */
export function formatVolumeTonnes(value: number, compact = false): string {
  const rounded = Math.round(value);

  if (compact && Math.abs(rounded) >= 10_000) {
    return compactVolumeFormatter.format(rounded);
  }

  return volumeFormatter.format(rounded);
}

export function formatVolumeLabel(value: number): string {
  return `${formatVolumeTonnes(value)} T`;
}
